import { render, staticRenderFns } from "./PayPlanPeriodStateBadge.vue?vue&type=template&id=72f701ca&scoped=true"
import script from "./PayPlanPeriodStateBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./PayPlanPeriodStateBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayPlanPeriodStateBadge.vue?vue&type=style&index=0&id=72f701ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f701ca",
  null
  
)

export default component.exports